import { jsx } from 'react/jsx-runtime';
import { DecoratorNode } from 'lexical';
import { DATA_ATTRIBUTE, TEXT_TYPE_TO_FORMAT, IS_BOLD, IS_ITALIC, IS_UNDERLINE } from './constants.mjs';
import { HashPlaceholderComponent } from './HashPlaceholderComponent.mjs';

class HashPlaceholderNode extends DecoratorNode {
  constructor(placeholderInfo, key) {
    super(key);
    this.__placeholderInfo = placeholderInfo;
    this.__format = 0;
  }
  static getType() {
    return "placeholder-chip";
  }
  static clone(node) {
    return new HashPlaceholderNode(node.__placeholderInfo, node.__key);
  }
  decorate() {
    return /* @__PURE__ */ jsx(
      HashPlaceholderComponent,
      {
        displayText: this.__placeholderInfo.displayText
      }
    );
  }
  createDOM() {
    const element = document.createElement("div");
    element.style.display = "inline-block";
    element.style.verticalAlign = "middle";
    return element;
  }
  updateDOM() {
    return false;
  }
  static importDOM() {
    return {
      span: (node) => convertNodeWithFormat(node),
      strong: (node) => convertNodeWithFormat(node, IS_BOLD),
      em: (node) => convertNodeWithFormat(node, IS_ITALIC),
      u: (node) => convertNodeWithFormat(node, IS_UNDERLINE)
    };
  }
  exportDOM() {
    let tag = "span";
    if (this.__format & IS_BOLD) {
      tag = "strong";
    } else if (this.__format & IS_ITALIC) {
      tag = "em";
    } else if (this.__format & IS_UNDERLINE) {
      tag = "u";
    }
    const element = document.createElement(tag);
    element.setAttribute(DATA_ATTRIBUTE, this.__placeholderInfo.displayText);
    const text = document.createTextNode(this.__placeholderInfo.template);
    element.append(text);
    return { element };
  }
  static importJSON(serializedNode) {
    const { displayText, template, format } = serializedNode;
    return $createHashPlaceholderNode({ displayText, template }, format);
  }
  exportJSON() {
    return {
      type: "placeholder-chip",
      displayText: this.__placeholderInfo.displayText,
      template: this.__placeholderInfo.template,
      format: this.__format,
      version: 1
    };
  }
  isInline() {
    return true;
  }
  setFormat(format) {
    const self = this.getWritable();
    const _format = typeof format === "string" ? TEXT_TYPE_TO_FORMAT[format] : format;
    if (_format === void 0) {
      console.warn(
        "[packages/flexical] _format === undefined \uC778 \uC0C1\uD669\uC774 \uC758\uB3C4\uC778\uC9C0 \uD655\uC778\uD574 \uC8FC\uC138\uC694."
      );
    }
    self.__format = _format;
    return self;
  }
}
function convertNodeWithFormat(node, format) {
  if (!node.hasAttribute(DATA_ATTRIBUTE)) {
    return null;
  }
  return {
    conversion: (e) => convertHashPlaceholderNode(e, format),
    priority: 1
  };
}
function convertHashPlaceholderNode(domNode, format) {
  const template = domNode.textContent;
  const displayText = domNode.getAttribute(DATA_ATTRIBUTE);
  if (!template || !displayText) {
    return null;
  }
  const node = $createHashPlaceholderNode({ template, displayText }, format);
  return { node };
}
function $createHashPlaceholderNode(placeholderInfo, format) {
  const node = new HashPlaceholderNode(placeholderInfo);
  if (typeof format === "number") {
    node.setFormat(format);
  }
  return node;
}
function $isHashPlaceholderNode(node) {
  return node instanceof HashPlaceholderNode;
}

export { $createHashPlaceholderNode, $isHashPlaceholderNode, HashPlaceholderNode };
//# sourceMappingURL=HashPlaceholderNode.mjs.map
